export default {"src":"/_next/static/media/KOSS.196f264f.svg","height":18,"width":18};